import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { loadTracking } from "@/lib/tracking";

export const CookieBanner = () => {
  const [show, setShow] = useState(false);
  const loc = useLocation();

  useEffect(() => {
    const c = localStorage.getItem("cookie_consent");
    if (!c) setShow(true);
    else loadTracking();
  }, []);

  if (!show || loc.pathname.startsWith("/studio")) return null;

  const choose = (v) => {
    localStorage.setItem("cookie_consent", v);
    setShow(false);
    loadTracking();
  };

  return (
    <div data-testid="cookie-banner" className="fixed bottom-0 inset-x-0 z-50 p-3 sm:p-5">
      <div className="max-w-4xl mx-auto bg-navy text-white rounded-xl shadow-2xl border border-white/10 p-5 flex flex-col sm:flex-row gap-4 sm:items-center">
        <p className="text-sm text-slate-300 flex-1">
          Utilizziamo cookie tecnici necessari e, previo consenso, cookie di misurazione (Google Analytics, Meta) per migliorare il servizio.{" "}
          <Link to="/cookie" className="text-gold underline underline-offset-2">Cookie policy</Link>
        </p>
        <div className="flex gap-2 shrink-0">
          <Button data-testid="cookie-reject-btn" variant="outline" className="bg-transparent text-white border-white/30 hover:bg-white/10 hover:text-white" onClick={() => choose("necessary")}>Solo necessari</Button>
          <Button data-testid="cookie-accept-btn" className="bg-gold text-navy hover:bg-gold-dark" onClick={() => choose("all")}>Accetta tutti</Button>
        </div>
      </div>
    </div>
  );
};
